import { lazy } from 'react'
import { RouteObject } from 'react-router'

const SalesTeamPerfomance = lazy(() => import('./SalesTeamPerfomance'))

export const SALES_MOVEMENT_PATH = {
  SUBMENU: '/business-insight/:projectID/sales-movement',
}

const SalesTeamPerformanceRoutes: RouteObject[] = [
  {
    path: 'sales-team-performance',
    children: [
      {
        path: '',
        element: <SalesTeamPerfomance />,
      },
    ],
  },
]

export default SalesTeamPerformanceRoutes
